<template>
  <div class="page-wrapper">
    <!-- Tabs Wrapper -->
    <div class="tabs-wrapper">
      <b-tabs lazy>
        
       
          
            <b-tab title="Enumerators" active>
              <ulu-enums-tab ref="enumsTab" />
            </b-tab>
            <b-tab :title="$t('globals.fieldtracker_task_name')">
              <ulu-ft-tasks-tab ref="ftTasksTab" />
            </b-tab>
            <b-tab :title="$t('globals.agents')">
              <ulu-agents-tab ref="agentsTab" />
            </b-tab>
       
        
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    "ulu-enums-tab": () => import("@/components/admin/enums/AllEnums"),
    "ulu-ft-tasks-tab": () => import("@/components/admin/fieldtracker/AllTasks"),
    "ulu-agents-tab": () => import("@/components/admin/agents/AllAgents")
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
  created() {
    if (!this.getUserBrandPermissions.super_admin) {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>
